module.exports = __webpack_public_path__ + "static/img/1-2-3.929cc3f5.jpg";